import { create } from 'zustand';
import { useLocalStorageStore } from './localStorageStore'; // Import the new store

export const userStore = create((set, get) => ({
  // Initialize userData from localStorageStore or default to {}
  userData: useLocalStorageStore.getState().userData || {},

  // Update userData in this store and in localStorageStore
  updateUserData: (data) => {
    const updatedData = { ...get().userData, ...data };
    useLocalStorageStore.getState().updateUserData(updatedData); // Update localStorageStore
    set({ userData: updatedData }); // Update local state
  },

  // Set userData in this store and in localStorageStore
  setUserData: (data) => {
    useLocalStorageStore.getState().setUserData(data); // Update localStorageStore
    set({ userData: data }); // Update local state
  },

  // Clear userData in this store and in localStorageStore
  clearUserData: () => {
    useLocalStorageStore.getState().clearUserData(); // Clear in localStorageStore
    set({ userData: {} }); // Clear local state
  },

  // Get user ID from userData
  getUserId: () => {
    return get().userData.user_id || get().userData.user;
  },
}));

// Optional: Subscribe to changes in localStorageStore to keep userStore in sync
// This is useful if userData can be changed directly through localStorageStore elsewhere
// and userStore needs to reflect that change immediately.
useLocalStorageStore.subscribe((newLocalStorageState, oldLocalStorageState) => {
  // Check if userData in localStorageStore has changed
  if (newLocalStorageState.userData !== oldLocalStorageState.userData) {
    // Update userStore's userData if it's different
    if (userStore.getState().userData !== newLocalStorageState.userData) {
      userStore.setState({ userData: newLocalStorageState.userData || {} });
    }
  }
});
